import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid, Button, CircularProgress } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomBreadcrumbs from '../Breadcrumb';
import { getVendorData } from '../../ReduxStore/VendorDataSlice';
import { createUserforBroadcastChannel, getBroadcastChannels, getBroadcastChannelUsers } from '../../ReduxStore/NotificationSlice';
import { getUsersforDOA } from '../../ReduxStore/AssetDisposalSlice';
import { getAllDepartments } from '../../ReduxStore/MastertableSlice';
import { sanitizeForDisplay } from '../../utils/inputSanitization';


const AddBroadcastUsers = () => {
    const dispatch = useDispatch();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Settings', href: '/settings' },
        { label: 'Mail Management', href: '/mail-management' }
    ];

    const [loadings, setLoading] = useState(true);
    const [users, setUsers] = useState([]);
    const [broadcastUsers, setBroadcastUser] = useState([]);
    const [userOptions, setUserOptions] = useState([]);
    const [channelOptions, setChannelOptions] = useState([]);
    const [broadcastChannels, setChannels] = useState([]);
    const [SupplierOptions, setSupplierOptions] = useState(null);
    const [selectedSupplier, setselectedSupplier] = useState(null);
    const [departments, setDepartment] = useState([]);
    const [departmentOptions, setDepartmentOptions] = useState(null);
    const [selectedChannel, setselectedChannel] = useState(null);
    const [selectedUser, setselectedUser] = useState(null);
    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [isSupplierSelected, setIsSupplierSelected] = useState(false);
    const { response } = useSelector(state => state.vendor);



    const handleDepartmentChange = (selectedOption) => {
        setSelectedDepartment(selectedOption);
        if (selectedOption && selectedOption.label === 'supplier') {
            setIsSupplierSelected(true);
        } else {
            setIsSupplierSelected(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const customerId = "af33f9117ecb4d8d8def84d6331eebd4";
        const asset_ids = []

        if (selectedDepartment.label === "Administration") {
            asset_ids.push(customerId);
        } else if (selectedDepartment?.label === 'supplier' && selectedSupplier) {
            asset_ids.push(selectedSupplier.value);
        }

        const payload = {
            user_id: selectedUser.value,
            channel_id: selectedChannel.value,
            // asset_ids: [selectedSupplier.value]
            asset_ids: asset_ids
        }
        console.log("check payload", payload)
        try {
            const action = dispatch(createUserforBroadcastChannel(payload));
            const response = await action.unwrap();
            console.log("check reposnse of  channel post--", response.result);
            if (response.StatusCode === 201) {
                toast.success(`User added to ${selectedChannel.label}`)
                setselectedChannel(null)
                setselectedSupplier(null)
                setselectedUser(null)
                setSelectedDepartment(null)
                getChannelUsers();
            }
        } catch (error) {
            toast.error(error.message || "Something went wrong!");
        }
    };


    useEffect(() => {

        const departmentlist = departments && departments.map(item => ({
            value: item.id,
            label: item.name,
        }));

        if (departmentlist) {
            setDepartmentOptions(departmentlist.map(item => ({
                value: item.value,
                label: item.label,
            })));
        }


        const Supplierlist = response && response.map(item => ({
            label: `${item.vendor_group} (${item.vendor})`,
            value: item.id
        }));

        if (Supplierlist) {
            setSupplierOptions(Supplierlist.map((item, index) => ({
                value: item.value,
                label: item.label
            })));
        }

        if (users.length > 0) {
            const UserList = users && users.map(item => ({
                value: item.id,
                label: item.name,
            }));

            if (UserList) {
                setUserOptions(UserList.map(item => ({
                    value: item.value,
                    label: item.label,
                })));
            }
        }

        if (broadcastChannels.length > 0) {
            const channelList = broadcastChannels && broadcastChannels.map(item => ({
                value: item.id,
                label: sanitizeForDisplay(item.name),
            }));

            if (channelList) {
                setChannelOptions(channelList.map(item => ({
                    value: item.value,
                    label: item.label,
                })));
            }
        }

    }, [broadcastChannels, departments, response, users]);

    const getChannels = async () => {
        try {
            const action = dispatch(getBroadcastChannels(`?customer_id=af33f9117ecb4d8d8def84d6331eebd4`));
            const res = await action.unwrap();
            console.log("getChannels", res.result);
            if (res.result) {
                setChannels(res.result);
            };
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "No Logs Found!");
        }
    }

    const getUserList = async () => {
        try {
            const action = dispatch(getUsersforDOA(`?customerID=af33f9117ecb4d8d8def84d6331eebd4`));
            const res = await action.unwrap();
            if (res.result) {
                setUsers(res.result)
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    }

    const getChannelUsers = async () => {
        try {
            const action = dispatch(getBroadcastChannelUsers(`?customer_id=af33f9117ecb4d8d8def84d6331eebd4`));
            const res = await action.unwrap();
            console.log("getChannels Users", res.result.broadcast_users);
            if (res.result) {
                setBroadcastUser(res.result.broadcast_users);
            };
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "No Logs Found!");
        }
    }

    const getDepartments = async () => {
        try {
            const action = dispatch(getAllDepartments(`?customerID=af33f9117ecb4d8d8def84d6331eebd4`));
            const res = await action.unwrap();
            console.log("check getDepartments", res.result)
            if (res.result) {
                setDepartment(res.result)
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            await getChannelUsers();
            await getChannels();
            await getUserList();
            await getDepartments();
            dispatch(getVendorData());
            setLoading(false);
        };
        fetchData();
    }, [])

    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <ResponsiveTypography>
                        Add Broadcast User
                    </ResponsiveTypography>
                </Box> */}
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Add Broadcast User" />
                </Box>
                <Box className="add-checkpoint" mb={3}>
                    <Grid container className='row1' spacing={3}>
                        <Grid item xs={12} sm={3}>
                            <Typography variant="body1" style={{ fontSize: '16px', fontWeight: 500 }}>
                                Add User to Broadcast Channel
                            </Typography>
                        </Grid>
                    </Grid>
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={3} alignItems="center">
                            <Grid item xs={12} sm={3}>
                                <Select
                                    options={userOptions}
                                    placeholder="Select User"
                                    isSearchable
                                    isClearable
                                    value={selectedUser}
                                    menuPlacement="auto"
                                    onChange={setselectedUser}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <Select
                                    options={channelOptions}
                                    placeholder="Select Broadcast Channel"
                                    isSearchable
                                    value={selectedChannel}
                                    isClearable
                                    menuPlacement="auto"
                                    onChange={setselectedChannel}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Select
                                    // styles={customStyles}
                                    options={departmentOptions}
                                    placeholder="Select Department"
                                    isSearchable
                                    // onChange={setSelectedDepartment}
                                    onChange={handleDepartmentChange}
                                    value={selectedDepartment}
                                    isClearable
                                    menuPlacement="auto"
                                />
                            </Grid>
                            {isSupplierSelected && <Grid item xs={12} sm={4}>
                                <Select
                                    // styles={customStyles}
                                    options={SupplierOptions}
                                    placeholder="Select Supplier"
                                    isSearchable
                                    value={selectedSupplier}
                                    onChange={setselectedSupplier}
                                    isClearable
                                    menuPlacement="auto"
                                />
                            </Grid>}
                            {/* <Grid item xs={12} sm={3}>
                                <Select
                                    options={SupplierOptions}
                                    placeholder="Select Vendor"
                                    isSearchable
                                    isClearable
                                    value={selectedSupplier}
                                    menuPlacement="auto"
                                    onChange={setselectedSupplier}
                                />
                            </Grid> */}
                            <Grid item xs={12} sm={2}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    size="medium"
                                    // fullWidth
                                    // color="primary"
                                    style={{ backgroundColor: 'green', color: 'white' }}
                                >
                                    Save User
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </Box>


                <Box className="add-checkpoint">
                    <Grid container className='row1' spacing={3}>
                        <Grid item xs={12} sm={3}>
                            <Typography variant="body1" style={{ fontSize: '16px', fontWeight: 500 }}>
                                Broadcast Users List
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} alignItems='center'>
                        <Grid item xs={2} sm={1}>
                            <h4>Sr.no.</h4>
                        </Grid>
                        <Grid item xs={3} sm={2}>
                            <h4>User Name</h4>
                        </Grid>
                        <Grid item xs={3} sm={3}>
                            <h4>Channel Name</h4>
                        </Grid>
                        <Grid item xs={3} sm={2}>
                            <h4>Added By</h4>
                        </Grid>
                    </Grid>
                    <hr />
                    {loadings ? (
                        <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        broadcastUsers.length > 0 && broadcastUsers.map((item, index) => (
                            <Grid container spacing={3} key={index} alignItems='center'>
                                <Grid item xs={2} sm={1}>
                                    {index + 1}
                                </Grid>
                                <Grid item xs={3} sm={2}>
                                    {item.user_name}
                                </Grid>
                                <Grid item xs={3} sm={3}>
                                    {sanitizeForDisplay(item.channel_name)}
                                </Grid>
                                <Grid item xs={3} sm={2}>
                                    {item.added_user_name}
                                </Grid>
                            </Grid>
                        ))
                    )}
                    <hr />
                </Box>
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default AddBroadcastUsers;
